<template>
  <div id="app">
    <!-- <OneMenu /> -->
    <nav-menu />
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
    <foot-er />
    <el-dialog :close-on-click-modal='false' :title="$t('uc.regist.pwd') + $t('uc.safe.set')"
      :visible.sync="dialogVisible" :showClose="false" width="40%">
      <div>
        <el-form label-position="left" label-width="80px" :model="form">
          <el-form-item :label="$t('uc.regist.pwd')">
            <el-input v-model="form.name" :placeholder="$t('uc.regist.pwdtip')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ok">{{
      $t("common.ok")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import navmenu from '@/components/NavMenu'
import OneMenu from '@/components/OneMenu'
import footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    'nav-menu': navmenu,
    'foot-er': footer,
    OneMenu
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: ''
      }
    }
  },

  created() {
    this.getSecurity()
    this.getconfigLists()
    if (this.member) {
      this.getexchangerate()
    } else {
      // console.log(JSON.parse(localStorage.getItem('USDTLIST')));
      // this.$store.commit("setusdtLit", JSON.parse(localStorage.getItem('USDTLIST')));
      this.$store.commit("initusdtLit");
    }
  },
  computed: {
    isLogin: function () {
      return this.$store.getters.isLogin;
    },
    member: function () {
      return JSON.parse(localStorage.getItem('MEMBER'));
    },
  },
  methods: {
    getexchangerate() {
      this.$http.get(this.host + "/uc/exchangerate/findMemberExchangeRate" + `?memberId=${this.member ? this.member.id : ''}`).then((response) => {
        var resp = response.body;
        if (resp.code == 0) {
          if (this.member) {
            this.$store.commit("setusdtLit", resp.data);
          } else {
            this.$store.commit("setusdtLit", {
              alias: "United States Dollar",
              createTime: 1709721002000,
              displaySymbol: "0024",
              exchangeRate: 1,
              status: 1,
              unitCode: "USD",
              updateTime: 1709721002000
            });
          }
        }
      });
    },
    handleClose() {
      this.dialogVisible = false
    },
    getconfigLists() {
      this.$http
        .get(this.host + "/uc/config/domain" + `?domain=${window.location.hostname.includes('www.') ? window.location.hostname.replace('www.', 'api.') : 'localhost'}`)
        .then(response => {
          var res = response.body;
          this.$store.commit("setconfigList", res.data);
          window.document.title = res.data.title
          this.changeFavicon(res.data.logo)
        });
    },
    changeFavicon(link) {
      let $favicon = window.document.querySelector('link[rel="icon"]');
      if ($favicon !== null) {
        $favicon.href = link;
      } else {
        $favicon = window.document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        window.document.head.appendChild($favicon);
      }
    },
    getSecurity() {
      if (localStorage.getItem('ISLOGINS') == 1) {
        this.$http
          .post(this.host + "/uc/approve/security/setting")
          .then(response => {
            var res = response.body;
            if (!res.data.passwordVerified) {
              this.dialogVisible = true
            }
          });
      }
    },
    ok() {
      if (!this.form.name) return this.$Message.error(this.$t("uc.regist.pwdtip"));
      this.$http
        .post(this.host + "/uc/dapp/set-password", {
          password: this.form.name
        })
        .then(response => {
          var res = response.body;
          if (res.code == 0) {
            this.dialogVisible = false
            this.$Message.success(res.message);
            localStorage.setItem("ISLOGINS", 0);
          } else {
            this.$Message.error(res.message);
          }
        });

    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #61688A;
  /* background: #1e2834; */
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-table,
.el-table__expanded-cell {
  background: none;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #27313e !important;
}


.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #27313e !important;
}

.el-table tbody tr:hover>td {
  background: #1e2834 !important;
}

.el-table__empty-block {
  background: #1e2834 !important;
}

.el-loading-mask {
  background: #192330 !important;
}

/* 去除分页背景 */
.el-pagination .btn-next {
  background: none !important;
}

.el-pagination .btn-prev {
  background: none !important;
}

.el-pager li {
  background: none !important;
}

/* 隐藏table的滚动条 */
::v-deep .el-table__body-wrapper {
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

::v-deep .el-table th.gutter {
  display: none;
  width: 0
}

::v-deep .el-table colgroup col[name='gutter'] {
  display: none;
  width: 0;
}

::v-deep .el-table__body {
  width: 100% !important;
}

.el-table__empty-block {
  width: 100%;
}

::v-deep .el-table__header-wrapper {
  width: 100%;
}

/* 分页字体颜色 */
.el-pager {
  color: #61688A;
}
</style>



// WEBPACK FOOTER //
// src/App.vue